import { Pipe, PipeTransform } from "@angular/core";
import { ReflectionNote, ReflectionOverviewFilterName } from "../models/reflections.models";

@Pipe({ name: "filterNotes" })
export class NotesFilterPipe implements PipeTransform {
  public transform(notes: ReflectionNote[], filter: ReflectionOverviewFilterName): ReflectionNote[] {
    if (filter && filter !== "published") {
      return notes?.filter((note) => note.type === filter && (note.text?.length || note.gif?.id));
    }
    return notes;
  }
}
